import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the CallbackPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'callback',
  pure: false
})
export class CallbackPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(items: any[], callback: (item: any, callbackArgs?: any[]) => boolean, callbackArgs?: any[]): any {
    if (!items || !callback) {
        return items;
    }
    return items.filter(item => callback(item, callbackArgs));
  }
}



// WEBPACK FOOTER //
// ./src/pipes/callback/callback.ts